import React from 'react'
import { Flex, FlexProps } from '@grupoboticario/flora-react-flex'
import { forwardRef } from '@grupoboticario/flora-react-system'

export type GridProps = FlexProps

/**
 * @component
 * @name Grid
 * @description Grid component
 * @tutorial https://flora.gb.tech/docs/components/core/grid
 */
export const Grid = forwardRef<'div', GridProps>((props, forwardedRef) => {
  const {
    direction,
    align,
    justify,
    wrap,
    templateColumns,
    templateRows,
    gap,
    gapX,
    gapY,
    css,
    ...rest
  } = props

  return (
    <Flex
      ref={forwardedRef}
      css={{ ...css, display: 'grid' }}
      {...{ direction, align, justify, wrap, templateColumns, templateRows, gap, gapX, gapY }}
      {...rest}
    />
  )
})
